<template>
  <div v-if="compliance" id="complienceForm">
    <div class="form-group mb-3">
      <p class="mt-2 compliance-text-header">
        {{
          element.answer[0].type == "agreement"
            ? `${element.name}`
            : `${element.name}`
        }}
      </p>
      <span class="info">{{ $tc("signInOut.complianceHeader", 1) }}</span>
    </div>

    <div class="user-infocontainer">
      <p class="user-info" v-if="element.pivot && element.pivot.updated_at">
        {{ getDate(element.pivot.updated_at) }}<b> . </b> {{ $t("common.by") }}
        {{
          element.pivot.metadata[0]
            ? element.pivot.metadata[0].actionBy
            : element.pivot.notes
            ? JSON.parse(element.pivot.notes).actionBy
            : "User"
        }}<strong class="strong-txt">
          ({{
            element.pivot.full_name_action_by
              ? element.pivot.full_name_action_by
              : element.pivot.notes
              ? JSON.parse(element.pivot.notes).fullName
              : "-"
          }})</strong
        >
      </p>
    </div>

    <div
      class="form-group question-wrapper"
      v-for="(question, i) in compliance.answer"
      :key="i"
    >
      <!-- Question -->
      <p id="question-group" class="second-info">
        {{ i + 1 }}-
        <template v-if="!readMore[question.body]">
          {{ question.body.substring(0, 150) }}
        </template>

        <template v-if="readMore[question.body]">
          {{ question.body }}
        </template>

        <a
          class="read_more"
          v-if="!readMore[question.body] && question.body.length >= 200"
          @click="showMore(question.body)"
          >{{ $t('common.readMore') }}</a
        >
        <a
          class="read_more"
          v-if="readMore[question.body]"
          @click="showLess(question.body)"
          >{{ $t('common.readLess') }}</a
        >
      </p>

      <!-- <v-radio-group v-model="question.pivot.answer.text" @change="updatePivot(question, question.pivot.answer.text, i)">
        <v-radio :label="question.answers[0].text" :value="question.answers[0].text"/>
        <v-radio  :label="question.answers[1].text" :value="question.answers[1].text"/>
      </v-radio-group> -->
      <!-- <hr class="questions-divider" /> -->

      <b-form-radio-group
        v-model="question.pivot.answer.text"
        stacked
        @input="updatePivot(question, question.pivot.answer.text, i)"
      >
        <b-form-radio class="vp-mb-34" :value="question.answers[0].text">
          {{ question.answers[0].text }}
        </b-form-radio>

        <b-form-radio :value="question.answers[1].text">
          {{ question.answers[1].text }}
        </b-form-radio>
      </b-form-radio-group>
      <hr />
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: ["element", "index"],
  data() {
    return {
      compliance: null,
      answer: {},
      readMore: {},
    };
  },
  methods: {
    getDate(date) {
      return moment
        .utc(date)
        .tz(moment.tz.guess())
        .format("DD/MM/YYYY - h:mm A");
    },
    updatePivot(questionObj, userAnswer) {
      const answerObject = questionObj.answers.find(
        (answer) => answer.text == userAnswer
      );
      Object.assign(questionObj.pivot, {
        answer: {
          text: userAnswer,
          ...answerObject,
          complianceIndex: this.index,
        },
      });
      this.$emit("updateCompliance", this.compliance);
    },
    showMore(id) {
      this.$set(this.readMore, id, true);
    },
    showLess(id) {
      this.$set(this.readMore, id, false);
    },
  },
  beforeMount() {
    this.compliance = this.element;
  },
  destroyed() {
    this.compliance = [];
  },
};
</script>
<style lang="scss" scoped>
.user-infocontainer {
  background: #f7f7f7;
  p.user-info {
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    color: #939393;

    padding-top: 5px;
    padding-bottom: 5px;
    padding-inline-start: 11px;
    margin: 0px !important;
  }
}
.compliance-text-header {
  font-weight: 700;
  font-size: 16px;
  line-height: 19.2px;
  color: #939393;
  margin-bottom: 17px;
}
.read_more {
  width: 69px;
  height: 17px;
  inset-inline-start: 721px;
  top: 503px;

  font-weight: 700;
  font-size: 14px;
  line-height: 23.5px;
  text-decoration-line: underline !important;
  color: #2680eb;
}
#complienceForm {
  .info {
    font-weight: 400 !important;
    font-size: 16px;
    line-height: 23.5px;
    color: #606060 !important;
    opacity: 0.8;
  }
  .bv-no-focus-ring {
    margin-bottom: 30px;
  }
  .second-info {
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 15px;
    letter-spacing: 0.25px;
    color: rgba(96, 96, 96, 0.87);
    opacity: 0.8;
    word-break: break-all;
  }
}
</style>

<style lang="scss">
.question-wrapper {
  .v-input--radio-group__input {
    flex-direction: column !important;
  }
}
</style>
